const ru = {
  title: 'СОФИЯ ГРАНИТ',
  description: 'Памятники из гранита',
};

export default {
  ru,
};
